import { Nullable } from '@Models';
import { BookSectionView } from '@Selectors/publication/book/view/book-section.view';

export class BookView {
  id: string;
  name: string;
  armyLogo: Nullable<string>;
  armyName: string;
  sections: BookSectionView[];

  constructor(params: BookViewParams) {
    this.id = params.id;
    this.name = params.name;
    this.armyLogo = params.armyLogo;
    this.armyName = params.armyName;
    this.sections = params.sections;
  }
}

export type BookViewParams = {
  id: string;
  name: string;
  armyLogo: Nullable<string>;
  armyName: string;
  sections: BookSectionView[];
};
